export default "__VITE_ASSET__CMj$rxXp__"